import Page from './page';

export * from './page';

export { usePageContext } from './page-context';

export default Page;
